import * as Sentry from "@sentry/react";
import { scrubBreadcrumb, scrubEvent } from "./sentry-scrub";

/** Client Sentry for the owner SPA: exceptions only. No-ops unless VITE_SENTRY_DSN is set at build time. */
export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (!dsn?.trim()) return;

  Sentry.init({
    dsn: dsn.trim(),
    environment: (import.meta.env.VITE_CREW_ENV as string | undefined) || import.meta.env.MODE,
    release: import.meta.env.VITE_APP_COMMIT_SHA as string | undefined,
    tracesSampleRate: 0,
    sendDefaultPii: false,
    // An invite's token is in the join page's URL and its API calls (slice 6a §3.4).
    beforeSend: scrubEvent,
    beforeBreadcrumb: scrubBreadcrumb,
    // Exceptions only: console warnings and errors arrive as their breadcrumbs.
  });
}
